import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Card from "Components/Card.js";
import Container from "Components/Container.js";
import Link from "Components/Link.js";

const RATINGS = [
	{alt: "PEGI 3", src: "/assets/Raildays/ratings/pegi.png"},
	{alt: "ESRB Everyone", src: "/assets/Raildays/ratings/esrb.png"},
	{alt: "USK 0", src: "/assets/Raildays/ratings/usk.png"},
	{alt: "L in Brazil", src: "/assets/Raildays/ratings/brazil.png"},
	{alt: "3 in Russia", src: "/assets/Raildays/ratings/russia.png"},
	{alt: "IARC 3+ (Rest of World)", src: "/assets/Raildays/ratings/iarc.png"}
];

const Section = ({children, title}) => (
	<Box component="section" sx={{mb: {xs: 4, md: 5}}}>
		<Typography variant="h5" sx={{fontWeight: 800, mb: 2}}>
			{title}
		</Typography>
		<Box sx={{display: "grid", gap: 2, color: "#374151", lineHeight: 1.8}}>
			{children}
		</Box>
	</Box>
);

const RaildaysContactView = () => (
	<Box
		component="main"
		sx={{
			flexGrow: 1,
			mx: {xs: 2, md: 3, lg: 5},
			mb: {xs: 2, md: 3, lg: 5},
			backgroundColor: "#fff",
			borderRadius: 2
		}}
	>
		<Container display="block" px={{xs: 2, md: 6, lg: 10}} py={{xs: 4, md: 6}}>
			<Box sx={{textTransform: "uppercase"}}>
				<Breadcrumbs aria-label="Breadcrumb">
					<Link color="#e2b534" label="Home" uri="/" variant="body2" />
					<Typography color="#e2b534">Contact, Terms &amp; Privacy</Typography>
				</Breadcrumbs>
			</Box>

			<Typography variant="h4" sx={{mt: 2, fontWeight: 800, textTransform: "uppercase"}}>
				Contact, Terms &amp; Privacy
			</Typography>

			<Card
				px={0}
				py={0}
				style={{
					borderRadius: 12,
					boxShadow: "0 16px 40px rgba(15, 23, 42, 0.16)",
					marginTop: "2rem"
				}}
			>
				<Box sx={{p: {xs: 3, md: 4}, maxWidth: 1000}}>
					<Section title="About Raildays">
						<Typography>
							Raildays is the mechanism through which{" "}
							<Link inline={true} label="HOPS" uri="https://www.hops.org.uk" /> promotes heritage railway days out.
						</Typography>
						<Typography>
							Data in the app is contributed by heritage railway venues and edited by Raildays.
						</Typography>
						<Typography>
							You can download the app for{" "}
							<Link inline={true} label="iPhone" uri="https://apps.apple.com/gb/app/id1569791008" /> and{" "}
							<Link inline={true} label="Android" uri="https://play.google.com/store/apps/details?id=com.raildays.android" /> devices.
						</Typography>
					</Section>

					<Section title="Privacy">
						<Typography>
							The app requests access to your location in order to present railways and events nearest to you. Your location is not stored or shared.
						</Typography>
						<Typography>
							The Raildays app does not store or collect personal information from users.
						</Typography>
						<Typography>
							Some technical data, such as device type and IP address, is stored for operational use. Users are not identified from this data.
						</Typography>
					</Section>

					<Section title="Contact">
						<Typography>
							If you have any problems, please contact us at{" "}
							<Link inline={true} label="helpdesk@raildays.org" uri="mailto:helpdesk@raildays.org" />.
						</Typography>
					</Section>

					<Section title="Contributing Information / New Venues to the App">
						<Typography>
							If you would like to suggest a new venue for addition to the app, please take the following steps:
						</Typography>
						<Typography>
							If you work at the venue and the organisation uses HOPS tools, please contact your HOPS Administrator or Commercial Manager. They can add the information directly.
						</Typography>
						<Typography>
							If you work at the venue and the organisation does not use HOPS tools, please ask your Commercial Manager to contact{" "}
							<Link inline={true} label="helpdesk@raildays.org" uri="mailto:helpdesk@raildays.org" />. We can arrange access.
						</Typography>
						<Typography>
							If you do not work at the venue, please contact us directly by email and include as much detail as possible:
							venue name, address, phone number, website and social links, plus whether you are a visitor or an official representative.
						</Typography>
					</Section>

					<Section title="Age Rating">
						<Typography>
							Raildays is suitable for all ages. There is no violent, explicit or offensive content.
						</Typography>
						<Grid container spacing={2} sx={{maxWidth: 540, pt: 1}}>
							{RATINGS.map(rating => (
								<Grid item xs={4} sm={2} key={rating.alt}>
									<Box component="img" alt={rating.alt} src={rating.src} sx={{width: "100%", maxWidth: 80}} />
								</Grid>
							))}
						</Grid>
					</Section>

					<Section title="Acknowledgements">
						<Typography>
							Thank you to everyone from many different railways who contributed ideas, feedback and encouragement to the development of Raildays.
						</Typography>
						<Typography>
							Thank you also to{" "}
							<Link inline={true} label="Jack Boskett Media" uri="https://www.jackboskett.co.uk/" /> and Harry Bradley for providing photographs for use in the Raildays app and promotions.
						</Typography>
					</Section>
				</Box>
			</Card>
		</Container>
	</Box>
);

export default RaildaysContactView;
